import { Injectable } from '@angular/core';
import { Http, Response, Headers, RequestOptions, ResponseContentType } from '@angular/http';
import { Observable } from "rxjs/Observable";

import * as globalConst from '../../../../../constants';

@Injectable()
export class BulkRenewalService {

  private apiUrl = globalConst.baseAPI;  // URL para web api  
  private filters: any = null;
  private selectClients: Array<string> = new Array<string>();

  constructor(private http: Http) { }

  getProposal(ID: string) {
    return this.http
    .get(this.apiUrl + "/renewalLC/v1/proposal/" + ID, JSON.parse(localStorage.getItem('yara.connectionHeader')))
    .map((res: Response) => res.json())
    .catch(e => {
      if (e.status === 401) {
        return Observable.throw('Unauthorized');
      }
    });
  }

  exportExcel(ID: string) {
    const localStorageOptions = JSON.parse(localStorage.getItem('yara.connectionHeader'))
    const options = new RequestOptions({ headers: localStorageOptions.headers, responseType: ResponseContentType.Blob });
    return this.http
      .post(this.apiUrl + "renewalLC/v1/proposal/export/" + ID, null, options)
      .map(res => {
        return new Blob([res.blob()], { type: "application/octet-stream" });
      });
  }

  sendCommittee(ID: string) {
    return this.http
      .post(this.apiUrl + "renewalLC/v1/proposal/sendcommittee/" + ID, null, JSON.parse(localStorage.getItem('yara.connectionHeader')))
      .map((res: Response) => res.json()).catch(e => {
        if (e.status === 401) {
          return Observable.throw('Unauthorized');
        }
      });
  }

  getCommittee(ID: string) {
    return this.http
    .get(this.apiUrl + "/renewalLC/v1/proposal/getcommittee/" + ID, JSON.parse(localStorage.getItem('yara.connectionHeader')))
    .map((res: Response) => res.json())
    .catch(e => {
      if (e.status === 401) {
        return Observable.throw('Unauthorized');
      }
    });
  }

  setApproval(ID: string,approvalData):any {
    return this.http
    .post(this.apiUrl + "renewalLC/v1/proposal/sendapproval/" + ID, approvalData, JSON.parse(localStorage.getItem('yara.connectionHeader')))
    .map((res: Response) => res.json()).catch(e => {
      if (e.status === 401) {
        return Observable.throw('Unauthorized');
      }
    });
  }

  cancelProposal(ID: string) {
    return this.http
      .post(this.apiUrl + "renewalLC/v1/proposal/cancel/" + ID, null, JSON.parse(localStorage.getItem('yara.connectionHeader')))
      .map((res: Response) => res.json()).catch(e => {
        if (e.status === 401) {
          return Observable.throw('Unauthorized');
        }
      });
  }


}


// WEBPACK FOOTER //
// ./src/app/bulk-renewal/component/bulk-renewal/service/bulk-renewal.service.ts